module.exports = __webpack_public_path__ + "static/media/marketing-feature-2.61631f80.svg";